// extracted by mini-css-extract-plugin
export default {"recipes_filter":"RecipesFilter_recipes_filter__FYlfV"};